var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { clsx } from 'clsx';
const PageHeadingCore = (props) => {
    const { Button, Heading, Grid, GridColumn } = props.components;
    const { backButton, hideButton } = props, rest = __rest(props, ["backButton", "hideButton"]);
    /**
     * Hidden button is needed to center text
     */
    const renderButton = (isHidden = false) => {
        var _a;
        const buttonProps = Object.assign({ size: 'small', responsive: [{ breakPoint: 'sm', props: { size: 'default' } }], icon: '#arrow-left' }, backButton);
        const hiddenButtonProps = Object.assign(Object.assign({}, buttonProps), { id: undefined, attributes: {
                tabIndex: -1,
                'aria-hidden': true,
            } });
        return (React.createElement(GridColumn, { width: ['min'], className: clsx('page-heading__button', {
                'heading__button--hidden': isHidden,
            }, 
            /* istanbul ignore next */
            Array.isArray(hideButton) ? hideButton.map(i => `hidden-${i}`) : [], (_a = props.backButton) === null || _a === void 0 ? void 0 : _a.className), align: ['middle-xs'] }, isHidden ? React.createElement(Button, Object.assign({}, hiddenButtonProps)) : React.createElement(Button, Object.assign({}, buttonProps))));
    };
    const renderHeading = () => {
        const heading = React.createElement(Heading, Object.assign({ className: "h3 text-center text-left-sm" }, rest));
        if (props.textEdit) {
            const { buttonProps, buttonText, onClick } = props.textEdit;
            return (React.createElement(Grid, { noWrap: true, align: ['middle-xs'], gutter: "small" },
                React.createElement(GridColumn, { width: ['minmax'] }, heading),
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Button, Object.assign({ type: "text-color", link: true, icon: "#edit", iconSize: "xs" }, buttonProps, { text: buttonText, onClick: onClick })))));
        }
        return heading;
    };
    const renderSubContent = (props) => {
        return (React.createElement(GridColumn, { width: ['max'], align: ['middle-xs'] },
            React.createElement("p", { className: `text-center text-left-sm ${props.className}` }, props.content)));
    };
    return (React.createElement(Grid, { noWrap: true, verticalGutter: "none" },
        renderButton(),
        React.createElement(GridColumn, { width: ['max'], align: ['middle-xs'] },
            renderHeading(),
            props.subContent && renderSubContent(props.subContent)),
        renderButton(true)));
};
export default PageHeadingCore;
